"use strict";

var _interopRequireDefault = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.replace");
var _regenerator2 = _interopRequireDefault(require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _promoter = require("@/api/promoter");
var _utils = require("@/utils");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'Promoter',
  data: function data() {
    return {
      loading: false,
      sendLinkLoading: false,
      // 搜索表单
      searchForm: {
        companyName: '',
        linkStatus: null,
        isOverseas: null
      },
      // 分页信息
      currentPage: 1,
      pageSize: 10,
      totalCount: 42,
      // 推广商列表数据
      promoterList: [],
      // 统计数据
      activeCount: 0,
      newCount: 0,
      // 弹窗相关
      dialogVisible: false,
      isEditMode: false,
      // 时间选择器相关
      year: new Date().getFullYear(),
      years: [],
      // 图表数据
      chartData: {
        columns: ['日期', '访问量', '注册量', '转化率'],
        rows: [{
          date: '2024-01-01',
          visits: 1200,
          registrations: 120,
          conversion: 10
        }, {
          date: '2024-01-02',
          visits: 1900,
          registrations: 228,
          conversion: 12
        }, {
          date: '2024-01-03',
          visits: 1500,
          registrations: 135,
          conversion: 9
        }, {
          date: '2024-01-04',
          visits: 2000,
          registrations: 260,
          conversion: 13
        }, {
          date: '2024-01-05',
          visits: 1800,
          registrations: 180,
          conversion: 10
        }, {
          date: '2024-01-06',
          visits: 2200,
          registrations: 264,
          conversion: 12
        }, {
          date: '2024-01-07',
          visits: 1600,
          registrations: 176,
          conversion: 11
        }]
      },
      // 推广商表单数据
      promoterForm: {
        id: '',
        companyName: '',
        companyUrl: '',
        contactName: '',
        contactPhone: '',
        contactEmail: '',
        promoterCode: '',
        isOverseas: 0,
        country: '',
        landingPage: '',
        promoterLink: '',
        memberRegCommission: 0,
        orderCommission: 0,
        linkStatus: 1,
        bankName: '',
        settleBankAccount: '',
        cardholderName: '',
        settleBankName: '',
        swiftOrBic: '',
        province: '',
        city: '',
        postalCode: '',
        bankAddress: '',
        settlementCycle: 'monthly'
      },
      // 表单验证规则
      rules: {
        bankAddress: [{
          required: true,
          message: '请输入收款人银行地址',
          trigger: 'blur'
        }],
        settleBankName: [{
          required: true,
          message: '请输入开户名',
          trigger: 'blur'
        }],
        companyName: [{
          required: true,
          message: '请输入公司名称',
          trigger: 'blur'
        }],
        contactName: [{
          required: true,
          message: '请输入联系人姓名',
          trigger: 'blur'
        }],
        contactPhone: [{
          required: true,
          message: '请输入联系电话',
          trigger: 'blur'
        }],
        contactEmail: [{
          required: true,
          message: '请输入联系邮箱',
          trigger: 'blur'
        }, {
          type: 'email',
          message: '请输入正确的邮箱格式',
          trigger: 'blur'
        }],
        isOverseas: [{
          required: true,
          message: '请选择是否海外推广商',
          trigger: 'change'
        }],
        country: [{
          required: true,
          message: '请输入国家',
          trigger: 'blur'
        }],
        bankName: [{
          required: true,
          message: '请输入银行名称',
          trigger: 'blur'
        }],
        settleBankAccount: [{
          required: true,
          message: '请输入银行账号',
          trigger: 'blur'
        }],
        cardholderName: [{
          required: true,
          message: '请输入持卡人姓名',
          trigger: 'blur'
        }],
        landingPage: [{
          required: true,
          message: '请输入落地页url',
          trigger: 'blur'
        }, {
          type: 'url',
          message: '请输入正确的URL格式',
          trigger: 'blur'
        }],
        memberRegCommission: [{
          required: true,
          message: '请输入会员注册佣金',
          trigger: 'blur'
        }, {
          type: 'number',
          message: '请输入数字',
          trigger: 'blur'
        }],
        orderCommission: [{
          required: true,
          message: '请输入订单佣金比例',
          trigger: 'blur'
        }, {
          type: 'number',
          message: '请输入数字',
          trigger: 'blur'
        }],
        province: [{
          required: true,
          message: '请输入收款人所在省',
          trigger: 'blur'
        }],
        city: [{
          required: true,
          message: '请输入收款人所在市',
          trigger: 'blur'
        }],
        postalCode: [{
          required: true,
          message: '请输入收款人所在邮编',
          trigger: 'blur'
        }],
        swiftOrBic: [{
          required: true,
          message: '请输入SWIFT/BIC码',
          trigger: 'blur'
        }]
      }
    };
  },
  created: function created() {
    this.handleQuery();
    // 生成年份选项，从当前年份-10到当前年份
    var currentYear = new Date().getFullYear();
    for (var i = currentYear - 10; i <= currentYear; i++) {
      this.years.push(i);
    }
  },
  methods: {
    initChart: function initChart(year) {
      var echarts = require('echarts');
      var chartDom = document.getElementById('conversionChart');
      var myChart = echarts.init(chartDom);
      var n = [];
      for (var i = 1; i <= 12; i++) {
        n.push(i + "月");
      }
      console.log(this.promoterForm, 'this.promoterForm');
      var clickCounts = this.promoterForm.monthlyClickCounts || [];
      var orderCounts = this.promoterForm.monthlyOrderCounts || [];
      var RegCounts = this.promoterForm.monthlyRegCounts || [];
      var option = {
        title: {
          text: "".concat(year, "\u5E74\u4F1A\u8425\u9500\u6570\u636E"),
          left: 'center',
          textStyle: {
            fontSize: 16,
            fontWeight: 'bold'
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross'
          }
        },
        legend: {
          data: ['点击量', '注册量', '订单量'],
          top: 30
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: n
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: '{value}'
          }
        },
        series: [{
          name: '点击量',
          type: 'line',
          data: clickCounts,
          lineStyle: {
            color: '#409eff'
          },
          itemStyle: {
            color: '#409eff'
          }
        }, {
          name: '注册量',
          type: 'bar',
          data: RegCounts,
          itemStyle: {
            color: '#67c23a'
          }
        }, {
          name: '订单量',
          type: 'bar',
          data: orderCounts,
          itemStyle: {
            color: '#e6a23c'
          }
        }]
      };
      myChart.setOption(option);
      window.addEventListener('resize', function () {
        myChart.resize();
      });
    },
    handleYearChange: function () {
      var _handleYearChange = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(year) {
        var _this = this;
        var response, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              this.year = year;
              if (!(this.isEditMode && this.promoterForm.id)) {
                _context.n = 5;
                break;
              }
              _context.p = 1;
              _context.n = 2;
              return (0, _promoter.info)({
                id: this.promoterForm.id,
                year: year
              });
            case 2:
              response = _context.v;
              if (response.data.errno === 0) {
                this.promoterForm = (0, _objectSpread2.default)({}, response.data.data);
                this.$nextTick(function () {
                  _this.initChart(year);
                });
              } else {
                this.$message.error(response.data.errmsg || '获取推广商信息失败');
              }
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              console.error('获取推广商详情失败:', _t);
              this.$message.error('获取详情失败，请重试');
            case 4:
              _context.n = 6;
              break;
            case 5:
              this.initChart(year);
            case 6:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3]]);
      }));
      function handleYearChange(_x) {
        return _handleYearChange.apply(this, arguments);
      }
      return handleYearChange;
    }(),
    handleIsOverseasChange: function handleIsOverseasChange(data) {
      console.log('ddd', data);
      var url;
      var lang = data ? 'en' : 'zh';
      console.log(process.env.NODE_ENV, 'process.env.NODE_ENV');
      if (process.env.NODE_ENV == 'development') {
        if (data) {
          url = "https://testglobal.theinniverse.com.cn/en/advertise";
        } else {
          url = "https://test.theinniverse.com.cn/zh/advertise";
        }
      } else {
        if (data) {
          url = "https://www.theinniverse.com/en/advertise";
        } else {
          url = "https://www.theinniverse.com.cn/zh/advertise";
        }
      }
      this.promoterForm.landingPage = url;
    },
    // 查询
    handleQuery: function () {
      var _handleQuery = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var params, _yield$list, data, _t2;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              params = {
                companyName: this.searchForm.companyName,
                linkStatus: this.searchForm.linkStatus,
                isOverseas: this.searchForm.isOverseas,
                limit: this.pageSize,
                page: this.currentPage
              };
              _context2.p = 1;
              _context2.n = 2;
              return (0, _promoter.list)(params);
            case 2:
              _yield$list = _context2.v;
              data = _yield$list.data;
              if (data.errno === 0) {
                this.promoterList = data.data.list;
                this.totalCount = data.data.total;
              } else {
                this.$message.error(data.errmsg || '获取数据失败');
              }
              _context2.n = 4;
              break;
            case 3:
              _context2.p = 3;
              _t2 = _context2.v;
              console.error('查询推广商列表失败:', _t2);
              this.$message.error('查询失败，请重试');
            case 4:
              return _context2.a(2);
          }
        }, _callee2, this, [[1, 3]]);
      }));
      function handleQuery() {
        return _handleQuery.apply(this, arguments);
      }
      return handleQuery;
    }(),
    // 重置搜索
    handleReset: function handleReset() {
      this.searchForm = {
        companyName: '',
        linkStatus: null,
        isOverseas: null
      };
      this.handleQuery();
    },
    // 导出数据
    handleExport: function () {
      var _handleExport = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3() {
        var res, _t3;
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              _context3.p = 0;
              this.loading = true;
              _context3.n = 1;
              return (0, _promoter.download)(this.searchForm);
            case 1:
              res = _context3.v;
              this.loading = false;
              if (res.data.errno == 0) {
                (0, _utils.downloadByUrl)('推广商数据.xlsx', res.data.data);
                // const url = window.URL.createObjectURL(new Blob([res.data.data]))
                // const link = document.createElement('a')
                // link.style.display = 'none'
                // link.href = url
                // link.setAttribute('download', '推广商数据.xlsx')
                // document.body.appendChild(link)
                // link.click()
              }
              this.$message.success('导出成功');
              _context3.n = 3;
              break;
            case 2:
              _context3.p = 2;
              _t3 = _context3.v;
              console.error('导出数据失败:', _t3);
              this.$message.error('导出失败，请重试');
            case 3:
              return _context3.a(2);
          }
        }, _callee3, this, [[0, 2]]);
      }));
      function handleExport() {
        return _handleExport.apply(this, arguments);
      }
      return handleExport;
    }(),
    // 新增推广商
    handleAddPromoter: function handleAddPromoter() {
      var url;
      var lang = this.isOverseas == 1 ? 'en' : 'zh';
      if (process.env.NODE_ENV == 'development') {
        url = "https://test.theinniverse.com.cn/".concat(lang, "/advertise");
      } else {
        url = "https://www.theinniverse.com.cn/".concat(lang, "/advertise");
      }
      // this.promoterForm.landingPage=url
      // 重置表单
      this.$refs.promoterForm && this.$refs.promoterForm.resetFields();
      this.promoterForm = {
        id: '',
        companyName: '',
        companyUrl: '',
        contactName: '',
        contactPhone: '',
        contactEmail: '',
        promoterCode: '',
        isOverseas: 0,
        country: '',
        landingPage: url,
        promoterLink: '',
        memberRegCommission: null,
        orderCommission: null,
        linkStatus: 1,
        bankName: '',
        settleBankAccount: '',
        cardholderName: '',
        swiftOrBic: '',
        settlementCycle: 'monthly'
      };
      this.isEditMode = false;
      this.dialogVisible = true;
    },
    copyLink: function copyLink(row) {
      var _this2 = this;
      // 复制推广商链接
      var landingPage = row.landingPage;
      var textToCopy = landingPage + '?source=' + row.promoterCode;
      console.log('row', row.isOverseas);
      if (row.isOverseas == 1) {
        textToCopy = textToCopy.replace('/zh/', '/en/');
      }
      if (!row.promoterCode) {
        this.$message.warning('没有可复制的链接');
        return;
      }

      // 使用现代剪贴板API
      if (navigator.clipboard && window.isSecureContext) {
        // 现代浏览器支持的方式
        navigator.clipboard.writeText(textToCopy).then(function () {
          _this2.$message.success('链接复制成功');
        }).catch(function (err) {
          console.error('复制失败:', err);
          _this2.$message.error('复制失败，请重试');
        });
      } else {
        // 兼容性处理
        var textArea = document.createElement('textarea');
        textArea.value = textToCopy;
        textArea.style.position = 'fixed';
        textArea.style.left = '-999999px';
        textArea.style.top = '-999999px';
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        try {
          document.execCommand('copy');
          this.$message.success('链接复制成功');
        } catch (err) {
          console.error('复制失败:', err);
          this.$message.error('复制失败，请重试');
        } finally {
          document.body.removeChild(textArea);
        }
      }
    },
    // 编辑推广商
    handleEdit: function () {
      var _handleEdit = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee4(row) {
        var _this3 = this;
        var response, _t4;
        return (0, _regenerator2.default)().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              _context4.p = 0;
              _context4.n = 1;
              return (0, _promoter.info)({
                id: row.id,
                year: this.year
              });
            case 1:
              response = _context4.v;
              if (response.data.errno === 0) {
                this.promoterForm = (0, _objectSpread2.default)({}, response.data.data);
                this.isEditMode = true;
                this.dialogVisible = true;
                this.$nextTick(function () {
                  _this3.initChart(_this3.year);
                });
              } else {
                this.$message.error(response.data.errmsg || '获取推广商信息失败');
              }
              _context4.n = 3;
              break;
            case 2:
              _context4.p = 2;
              _t4 = _context4.v;
              console.error('获取推广商详情失败:', _t4);
              this.$message.error('获取详情失败，请重试');
            case 3:
              return _context4.a(2);
          }
        }, _callee4, this, [[0, 2]]);
      }));
      function handleEdit(_x2) {
        return _handleEdit.apply(this, arguments);
      }
      return handleEdit;
    }(),
    // 保存推广商
    handleSavePromoter: function () {
      var _handleSavePromoter = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee5() {
        var response, _t5;
        return (0, _regenerator2.default)().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              _context5.p = 0;
              _context5.n = 1;
              return this.$refs.promoterForm.validate();
            case 1:
              if (!this.isEditMode) {
                _context5.n = 3;
                break;
              }
              _context5.n = 2;
              return (0, _promoter.update)(this.promoterForm);
            case 2:
              response = _context5.v;
              _context5.n = 5;
              break;
            case 3:
              _context5.n = 4;
              return (0, _promoter.add)(this.promoterForm);
            case 4:
              response = _context5.v;
            case 5:
              if (response.data.errno === 0) {
                this.$message.success(this.isEditMode ? '修改成功' : '新增成功');
                this.dialogVisible = false;
                this.handleQuery();
              } else {
                this.$message.error(response.data.errmsg || (this.isEditMode ? '修改失败' : '新增失败'));
              }
              _context5.n = 7;
              break;
            case 6:
              _context5.p = 6;
              _t5 = _context5.v;
              if (_t5 !== 'cancel') {
                console.error(this.isEditMode ? '修改推广商失败:' : '新增推广商失败:', _t5);
                this.$message.error(this.isEditMode ? '修改失败，请重试' : '新增失败');
              }
            case 7:
              return _context5.a(2);
          }
        }, _callee5, this, [[0, 6]]);
      }));
      function handleSavePromoter() {
        return _handleSavePromoter.apply(this, arguments);
      }
      return handleSavePromoter;
    }(),
    // 删除推广商
    handleDelete: function handleDelete(row) {
      var _this4 = this;
      this.$confirm('确定要删除该推广商吗？删除后不可恢复。', '警告', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee6() {
        var response, _t6;
        return (0, _regenerator2.default)().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              _context6.p = 0;
              _context6.n = 1;
              return (0, _promoter.del)({
                id: row.id
              });
            case 1:
              response = _context6.v;
              if (response.data.errno === 0) {
                _this4.$message.success('推广商删除成功');
                // 重新查询列表
                _this4.handleQuery();
              }
              _context6.n = 3;
              break;
            case 2:
              _context6.p = 2;
              _t6 = _context6.v;
            case 3:
              return _context6.a(2);
          }
        }, _callee6, null, [[0, 2]]);
      }))).catch(function () {
        //  this.$message.info('已取消删除操作')
      });
    },
    // 分页变化
    handleCurrentChange: function () {
      var _handleCurrentChange = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee7(val) {
        var response, _t7;
        return (0, _regenerator2.default)().w(function (_context7) {
          while (1) switch (_context7.p = _context7.n) {
            case 0:
              console.log('当前页:', val);
              this.currentPage = val;
              _context7.p = 1;
              _context7.n = 2;
              return (0, _promoter.list)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.searchForm), {}, {
                page: this.currentPage,
                limit: this.pageSize
              }));
            case 2:
              response = _context7.v;
              if (response.data.errno === 0) {
                this.promoterList = response.data.data.list || [];
              } else {
                this.$message.error(response.data.errmsg || '获取数据失败');
              }
              _context7.n = 4;
              break;
            case 3:
              _context7.p = 3;
              _t7 = _context7.v;
              console.error('切换页码失败:', _t7);
              this.$message.error('获取数据失败，请重试');
            case 4:
              return _context7.a(2);
          }
        }, _callee7, this, [[1, 3]]);
      }));
      function handleCurrentChange(_x3) {
        return _handleCurrentChange.apply(this, arguments);
      }
      return handleCurrentChange;
    }(),
    // 每页条数变化
    handleSizeChange: function () {
      var _handleSizeChange = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee8(val) {
        var response, _t8;
        return (0, _regenerator2.default)().w(function (_context8) {
          while (1) switch (_context8.p = _context8.n) {
            case 0:
              console.log('每页条数:', val);
              this.pageSize = val;
              // 重置页码为1
              this.currentPage = 1;
              _context8.p = 1;
              _context8.n = 2;
              return (0, _promoter.list)((0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.searchForm), {}, {
                page: this.currentPage,
                limit: this.pageSize
              }));
            case 2:
              response = _context8.v;
              if (response.data.errno === 0) {
                this.promoterList = response.data.data.list || [];
                this.totalCount = response.data.data.total || 0;
              } else {
                this.$message.error(response.data.errmsg || '获取数据失败');
              }
              _context8.n = 4;
              break;
            case 3:
              _context8.p = 3;
              _t8 = _context8.v;
              console.error('切换每页条数失败:', _t8);
              this.$message.error('获取数据失败，请重试');
            case 4:
              return _context8.a(2);
          }
        }, _callee8, this, [[1, 3]]);
      }));
      function handleSizeChange(_x4) {
        return _handleSizeChange.apply(this, arguments);
      }
      return handleSizeChange;
    }(),
    // 发送链接
    handleSendLink: function () {
      var _handleSendLink = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee9() {
        var response, _t9;
        return (0, _regenerator2.default)().w(function (_context9) {
          while (1) switch (_context9.p = _context9.n) {
            case 0:
              this.sendLinkLoading = true;
              _context9.p = 1;
              _context9.n = 2;
              return (0, _promoter.sendLink)(this.promoterForm);
            case 2:
              response = _context9.v;
              if (response.data.errno === 0) {
                this.$message.success('发送链接成功');
              } else {
                this.$message.error(response.data.errmsg || '发送链接失败');
              }
              _context9.n = 4;
              break;
            case 3:
              _context9.p = 3;
              _t9 = _context9.v;
              console.error('发送链接失败:', _t9);
              this.$message.error('发送链接失败，请重试');
            case 4:
              _context9.p = 4;
              this.sendLinkLoading = false;
              return _context9.f(4);
            case 5:
              return _context9.a(2);
          }
        }, _callee9, this, [[1, 3, 4, 5]]);
      }));
      function handleSendLink() {
        return _handleSendLink.apply(this, arguments);
      }
      return handleSendLink;
    }(),
    // 切换链接状态
    handleLinkStatusChange: function () {
      var _handleLinkStatusChange = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee0(row) {
        var response, _t0;
        return (0, _regenerator2.default)().w(function (_context0) {
          while (1) switch (_context0.p = _context0.n) {
            case 0:
              _context0.p = 0;
              _context0.n = 1;
              return (0, _promoter.update)(row);
            case 1:
              response = _context0.v;
              if (response.data.errno !== 0) {
                // 如果失败，恢复原状态
                row.linkStatus = !row.linkStatus * 1;
                this.$message.error(response.data.errmsg || '更新状态失败');
              }
              _context0.n = 3;
              break;
            case 2:
              _context0.p = 2;
              _t0 = _context0.v;
              // 如果出错，恢复原状态
              row.linkStatus = !row.linkStatus;
              console.error('更新链接状态失败:', _t0);
              this.$message.error('更新状态失败，请重试');
            case 3:
              return _context0.a(2);
          }
        }, _callee0, this, [[0, 2]]);
      }));
      function handleLinkStatusChange(_x5) {
        return _handleLinkStatusChange.apply(this, arguments);
      }
      return handleLinkStatusChange;
    }()
  }
};